module.exports = __webpack_public_path__ + "static/media/13.7540fb30.svg";